import React from 'react';
import FeatureFlagGuard from './FeatureFlagGuard';

interface FeatureFlagConfig {
  featureName: string;
  allowedRoles: string[];
}

const CreateFeatureFlagGuard = ({ featureName, allowedRoles }: FeatureFlagConfig) => {
  const FeatureFlagGuardComponent = ({
    children,
    fallback,
    ...props
  }: {
    children: React.ReactNode;
    fallback?: React.ReactNode;
  }) => (
    <FeatureFlagGuard
      featureName={featureName}
      allowedRoles={allowedRoles}
      fallback={fallback}
      {...props}
    >
      {children}
    </FeatureFlagGuard>
  );

  FeatureFlagGuardComponent.displayName = `FeatureFlagGuard(${featureName})`;

  return FeatureFlagGuardComponent;
};

export default CreateFeatureFlagGuard;
